"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreMessages = void 0;
var CoreMessages;
(function (CoreMessages) {
    CoreMessages["CORE_MODULE_NOT_LOADED"] = "Module did not load, did you use the constructor?";
})(CoreMessages || (exports.CoreMessages = CoreMessages = {}));
//# sourceMappingURL=messages.js.map